import { Controller } from "@hotwired/stimulus"

// Dynamically updates the filter field dropdown options when the
// measure_model select changes on the objective form.
// The available fields per model are passed as a JSON data attribute.

export default class extends Controller {
  static targets = ["model", "fieldSelect", "aggregationKind", "aggregationField", "aggregationFieldWrapper"]
  static values = { fields: Object, columns: Object }

  connect() {
    this.updateFields()
    this.toggleAggregationField()
  }

  updateFields() {
    if (!this.hasFieldSelectTarget || !this.hasModelTarget) return

    const model = this.modelTarget.value
    const fields = this.fieldsValue[model] || []
    const select = this.fieldSelectTarget
    const tableName = model.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '') + 's'

    // Preserve current selection if still valid
    const current = select.value

    // Objective#labeled_field_names sends [label, field] pairs -- fall back to
    // treating a bare string as its own label for any caller still passing a
    // flat field list.
    const pairs = fields.map(field => Array.isArray(field) ? field : [field, field])

    // The field select may be wrapped by SlimSelect (data-controller="slim").
    // Rewriting the native <select>'s innerHTML directly doesn't reach Slim's
    // own rendered dropdown, so route through its setData API when present --
    // same pattern as distribution_matrix_filter_controller.js.
    const slimController = this.application.getControllerForElementAndIdentifier(select, "slim")

    if (slimController && slimController.select) {
      const data = [{ placeholder: true, text: `${tableName}.field`, value: "" }]
      pairs.forEach(([label, field]) => data.push({ text: label, value: field }))
      slimController.select.setData(data)
      if (pairs.some(([, field]) => field === current)) {
        slimController.select.setSelected(current)
      }
    } else {
      select.innerHTML = `<option value="">${tableName}.field</option>`
      pairs.forEach(([label, field]) => {
        const option = document.createElement("option")
        option.value = field
        option.textContent = label
        if (field === current) option.selected = true
        select.add(option)
      })
    }

    if (this.hasAggregationFieldTarget) {
      const columns = this.columnsValue[model] || []
      const currentAgg = this.aggregationFieldTarget.value
      this.aggregationFieldTarget.innerHTML = '<option value="">-- Select field --</option>'
      columns.forEach(field => {
        const option = document.createElement("option")
        option.value = field
        option.textContent = field
        if (field === currentAgg) option.selected = true
        this.aggregationFieldTarget.add(option)
      })
    }
  }

  toggleAggregationField() {
    if (!this.hasAggregationKindTarget || !this.hasAggregationFieldWrapperTarget) return
    const needsField = ["sum", "average", "count_distinct"].includes(this.aggregationKindTarget.value)
    this.aggregationFieldWrapperTarget.classList.toggle("hidden", !needsField)
  }
}
